import ApiService from "@/common/service.api";

// Uploads a File to the "Upload" endpoint and returns the stored file name (res.data).
// Throws on failure; the error keeps the axios config/response for buildErrorDetails.
export async function uploadFile(file) {
  // Copia in memoria: sgancia il file dal riferimento dell'input (fix WebKit/iOS)
  const buffer = await file.arrayBuffer();
  if (!buffer.byteLength) throw new Error("File vuoto letto dal dispositivo");
  const blob = new Blob([buffer], { type: file.type || "image/jpeg" });
  const fileName = file.name || `foto_${Date.now()}.jpg`;
  const formData = new FormData();
  formData.append("file", blob, fileName); // filename esplicito
  // Nessun Content-Type manuale: il browser imposta il boundary
  const res = await ApiService.post("Upload", formData);
  if (!res || !res.data) throw new Error("Risposta Upload vuota");
  return res.data;
}

// File info to put in the error details context
export function fileInfo(file) {
  if (!file) return null;
  return {
    name: file.name,
    type: file.type,
    sizeBytes: file.size,
    sizeMB: (file.size / 1024 / 1024).toFixed(2),
    lastModified: file.lastModified,
  };
}
